import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Callout — the prototype `.banner.info` (info-tone inline banner). An icon on
 * the left and rich text on the right. Used by AI Policy (inheritance note),
 * Constitution (ratification), and Billing (overage).
 */
const TONE = {
  info:    'bg-cs-info-bg/60 border-cs-info-500/25 text-cs-text-secondary [&_svg]:text-cs-info-400',
  warning: 'bg-cs-warning-bg/60 border-cs-warning-500/25 text-cs-text-secondary [&_svg]:text-cs-warning-400',
  success: 'bg-cs-success-bg/60 border-cs-success-500/25 text-cs-text-secondary [&_svg]:text-cs-success-400',
} as const;

export function Callout({
  icon: Icon,
  tone = 'info',
  className,
  children,
}: {
  icon?: React.ElementType;
  tone?: keyof typeof TONE;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      role="note"
      className={cn(
        'flex items-start gap-3 rounded-lg border px-4 py-3 text-[12.5px] leading-relaxed',
        TONE[tone],
        className,
      )}
    >
      {Icon && <Icon className="mt-0.5 h-4 w-4 flex-shrink-0" aria-hidden="true" />}
      <div className="min-w-0 [&_b]:text-cs-text-primary [&_b]:font-semibold">{children}</div>
    </div>
  );
}
